import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AccountAdminApiV2 } from '../../../../../../lib/api/account/admin/AccountAdminApiV2';
import { AccountAdminListQueryParamType, AccountAdminListResponse } from '../../types/AccountAdminFormType';
import { useNavigate } from 'react-router-dom';
import { AxiosError } from 'axios';
import { ErrorResponseType, extractErrorMessage } from '../../../../../../lib/utils/checkErrorResponse';
import toastMsg from '../../../../../../lib/toastMsg';

export const useAccountAdminList = (
  payload: AccountAdminListQueryParamType,
): UseQueryResult<AccountAdminListResponse, Error> => {
  const navigate = useNavigate();
  return useQuery(['accountAdminList', payload], () => AccountAdminApiV2.getAccountAdminList(payload), {
    onError: (error: AxiosError) => {
      const errorMessage = extractErrorMessage(error as ErrorResponseType);
      toastMsg.error(errorMessage);
      navigate('/account/admin/list?pageIndex=1&pageSize=100');
    },
    keepPreviousData: true,
  });
};
